var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"width":"100%"}},_vm._l((_vm.metrics),function(metric){return _c('MetricCard',{key:metric.id,attrs:{"metric":metric}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }